// extracted by mini-css-extract-plugin
module.exports = {"webpage-template":"WebpageTemplate_webpage-template__gvEY0","preFooterCta":"WebpageTemplate_preFooterCta__BLK3O"};